export default "__VITE_ASSET__s6B9GUFv__"